import React from "react"

export default function Button({
    children,
    variant = "primary",
    size = "md",
    className = "",
    type = "button",
    onClick,
    disabled = false,
    ...props
}) {
    const variantMap = {
        primary: "bg-main text-white hover:bg-main_dark transition-colors",
        "primary-white": "bg-white text-main hover:bg-main_light hover:text-white transition-colors",
        secondary: "bg-second text-white hover:bg-second_dark transition-colors",
        "secondary-outline": "border-2 border-second text-second hover:bg-second hover:text-white transition-colors",
        light: "bg-main_light text-white hover:bg-main transition-colors",
        "light-outline": "border-2 border-main_light text-main_light hover:bg-main_light hover:text-white transition-colors",
        ghost: "text-main hover:bg-main_light hover:text-white transition-colors"
    }

    const sizeMap = {
        sm: "px-3 py-1.5 text-sm rounded-md",
        md: "px-4 py-2 text-base rounded-md",
        lg: "px-6 py-3 text-lg rounded-lg",
        xl: "px-8 py-4 text-xl rounded-lg",
    }

    const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : ""
    const buttonClass = `${variantMap[variant] || variantMap.primary} ${sizeMap[size] || sizeMap.md} font-medium ${disabledClasses} ${className}`

    return (
        <button
            type={type}
            className={buttonClass}
            onClick={onClick}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    )
}
